import tingle from 'tingle.js';
import 'tingle.js/dist/tingle.min.css';

// Create a global variable to keep track of the currently opened modal

function videoModal() {
    let currentModal = null;

    // Function to transform a video URL into an embeddable format
    function transformVideoUrl(videoUrl) {
        if (videoUrl) {
            if (videoUrl.includes('vimeo.com')) {
                // Extract the video ID from the Vimeo URL
                const vimeoVideoID = videoUrl.match(/\/(\d+)/)[1];
                // Construct the Vimeo embed URL
                return `https://player.vimeo.com/video/${vimeoVideoID}`;
            } else if (videoUrl.includes('youtube.com')) {
                // Extract the video ID from the YouTube URL
                const youtubeVideoID = videoUrl.match(/v=([^&]+)/)[1];
                // Construct the YouTube embed URL
                return `https://www.youtube.com/embed/${youtubeVideoID}`;
            } else if (videoUrl.includes('.mp4') || videoUrl.includes('.webm') || videoUrl.includes('.ogv')) {

            }
        }
        return videoUrl;
    }

    const videoControls = document.querySelectorAll('.u-video');
    videoControls.forEach(videoControl => {
        videoControl.addEventListener("click", (e) => {
            e.preventDefault();
            const videoUrl = videoControl.getAttribute('data-video-url');
            const transformedVideoUrl = transformVideoUrl(videoUrl); // Transform the URL

            // Check if there's an existing modal, destroy it before creating a new one
            if (currentModal) {
                currentModal.destroy();
                currentModal = null; // Clear the current modal reference
            }

            let modalContent;

            if (videoUrl.includes('vimeo.com') || videoUrl.includes('youtube.com')) {
                // Use iframe for Vimeo or YouTube URLs
                modalContent = `<iframe src="${transformedVideoUrl}" preload="auto" autoplay width="800" height="450" frameborder="0" allow="autoplay" allowfullscreen></iframe>`;
            } else {
                // Use HTML5 video element for other URLs
                const desiredWidth = 800;
                modalContent = `
                    <video preload="auto" controls autoplay width="${desiredWidth}" height="auto">
                        <source src="${transformedVideoUrl}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                `;
            }

            // Create a new tingle modal instance
            const modal = new tingle.modal({
                footer: false,
                stickyFooter: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: "Close",
                cssClass: ['custom-class-1', 'custom-class-2'],
                onOpen: () => {
                    // console.log('modal open');
                    // Change the width of the video iframe after the modal is opened
                    // const mediaIframe = document.querySelector('iframe[name="media"]');
                    // console.log(mediaIframe);
                    // if (mediaIframe) {
                    // 	mediaIframe.style.width = `100%`;
                    // }
                },
                onClose: () => {
                    currentModal = null; // Clear the current modal reference on modal close
                    // console.log('close');
                    modal.destroy();
                },
                beforeClose: function() {
                    // here's goes some logic
                    // e.g. save content before closing the modal
                    return true; // close the modal
                    return false; // nothing happens
                }
            });

            // Set the modal content
            modal.setContent(modalContent);

            // Open the modal
            modal.open();

            currentModal = modal;
        });
    });
}
// videoModal();

//
// accordion
//
function accordion() {

    const accordions = document.querySelectorAll('.b-accordion__list');
    accordions.forEach(accordion => {



        const lists = accordion.querySelectorAll('li');


        // Open the first accordion item onload
        // if (lists.length > 0) {
        //     const firstList = lists[0];
        //     const firstText = firstList.querySelector('.answer');
        //     const firstHeight = firstText.scrollHeight;

        //     firstList.classList.add('active');
        //     firstList.setAttribute('aria-expanded', 'true');
        //     firstText.style.maxHeight = firstHeight + 'px';
        // }

        lists.forEach(list => {

            // console.log(list);

            const open = list.querySelector('.question');
            if (!open) {
                return;
            }

            open.addEventListener('click', (e) => {

                console.log('click');

                // Check if the clicked element is a button
                // if (e.target.tagName.toLowerCase() === 'button' && !e.target.classList.contains('question') || !e.target.classList.contains('question')) {
                if (e.target.classList.contains('answer')) {
                    // e.preventDefault();
                    return;
                }

				e.preventDefault();

                const text = list.querySelector('.answer');
                if (!text) {
                    return;
                }

                var height = text.scrollHeight;

                // Close other lists
                lists.forEach(otherList => {
                    if (otherList !== list) {
                        const otherText = otherList.querySelector('.answer');
                        if (otherText) {
                            otherText.style.setProperty('max-height', '0px');
                        }
                        // console.log(otherText.style);
                        otherList.classList.remove('active');
                        otherList.setAttribute('aria-expanded', 'false');
                    }
                });

                // Toggle current list
                var aria = list.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
                list.setAttribute('aria-expanded', aria);

                if (list.getAttribute('aria-expanded') === 'false') {
                    text.style.maxHeight = '0px';
                    list.classList.remove('active');
                    list.setAttribute('aria-expanded', 'false');
                } else {
                    text.style.maxHeight = height + 'px';
                    list.classList.add('active');
                    list.setAttribute('aria-expanded', 'true');
                }
            });
        });

    });
}
// document.addEventListener('load', accordion);
// document.addEventListener('DOMContentLoaded', accordion);
accordion();




/**
 * Toggle between map and listing views in projects listing
 * with smooth CSS transitions
 */
function initProjectListingToggle() {
    const toggleButton = document.querySelector('.test-button');

    if (!toggleButton) {
        console.log('Toggle button not found');
        return;
    }

    const projectsListing = document.querySelector('.b-projects');
    const listingView = document.querySelector('.b-projects__listing');
    const mapView = document.querySelector('.b-projects__map');

    if (!projectsListing || !listingView || !mapView) {
        console.log('Required elements not found');
        return;
    }

    // Flag to prevent multiple clicks during transition
    let isTransitioning = false;

    // Set initial state (listing view shown, map hidden)
    projectsListing.classList.add('toggle-listing');
    toggleButton.querySelector('.text').textContent = 'View Map';

    // Ensure proper initial styling
    listingView.style.opacity = '1';
    listingView.style.display = 'block';
    listingView.style.position = 'relative';
    mapView.style.opacity = '0';
    mapView.style.display = 'none';
    mapView.style.position = 'absolute';

    // Add click event listener
    toggleButton.addEventListener('click', (e) => {

        e.preventDefault();

        // Prevent rapid clicking
        if (isTransitioning) return;
        isTransitioning = true;

        console.log('Button clicked');

        // If currently showing listing, transition to map
        if (projectsListing.classList.contains('toggle-listing')) {
            // Step 1: Position both elements absolutely with fixed height
            const containerHeight = listingView.offsetHeight;
            projectsListing.style.height = `${containerHeight}px`;

            // Step 2: Make both elements visible but position them with absolute positioning
            mapView.style.display = 'block';
            mapView.style.opacity = '0';
            mapView.style.position = 'absolute';
            mapView.style.top = '0';
            mapView.style.left = '0';
            mapView.style.width = '100%';

            // Force reflow
            void projectsListing.offsetWidth;

            // Step 3: Crossfade
            listingView.style.opacity = '0';
            mapView.style.opacity = '1';

            // Step 4: After transition completes, adjust final positions
            setTimeout(() => {
                // Update text
                toggleButton.querySelector('.text').textContent = 'View List';

                // Make map relative to maintain flow
                mapView.style.position = 'relative';

                // Hide listing
                listingView.style.display = 'none';

                // Allow the container to adjust to content height
                projectsListing.style.height = 'auto';

                // Update classes for state
                projectsListing.classList.remove('toggle-listing');
                projectsListing.classList.add('toggle-map');

                // Reset flag
                isTransitioning = false;
            }, 400);
        }
        // If currently showing map, transition to listing
        else {
            // Step 1: Position both elements absolutely with fixed height
            const containerHeight = mapView.offsetHeight;
            projectsListing.style.height = `${containerHeight}px`;

            // Step 2: Make both elements visible but position them with absolute positioning
            listingView.style.display = 'block';
            listingView.style.opacity = '0';
            listingView.style.position = 'absolute';
            listingView.style.top = '0';
            listingView.style.left = '0';
            listingView.style.width = '100%';

            // Force reflow
            void projectsListing.offsetWidth;

            // Step 3: Crossfade
            mapView.style.opacity = '0';
            listingView.style.opacity = '1';

            // Step 4: After transition completes, adjust final positions
            setTimeout(() => {
                // Update text
                toggleButton.querySelector('.text').textContent = 'View Map';

                // Make listing relative to maintain flow
                listingView.style.position = 'relative';

                // Hide map
                mapView.style.display = 'none';

                // Allow the container to adjust to content height
                projectsListing.style.height = 'auto';

                // Update classes for state
                projectsListing.classList.remove('toggle-map');
                projectsListing.classList.add('toggle-listing');

                // Reset flag
                isTransitioning = false;
            }, 400);
        }
    });
}

// Initialize when DOM is ready
// initProjectListingToggle();

/**
 * Initializes animation for list items when they scroll into view
 */
function initAnimatedListItems() {
    // Check if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
        const animatedItems = document.querySelectorAll('.b-fifty_fifty .animate-item');

        console.log(animatedItems);

        if (animatedItems.length === 0) return; // Exit if no items found

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const delay = parseInt(entry.target.dataset.delay) || 0;

                    setTimeout(() => {
                        entry.target.classList.add('visible');
                    }, delay);

                    // Once animated, no need to observe anymore
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.2
        });

        animatedItems.forEach(item => {
            observer.observe(item);
        });
    }
}

// Initialize the animated list items
initAnimatedListItems();

/**
 * Initialize Google Maps for fifty_fifty blocks
 */
function initGoogleMaps() {
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        return;
    }

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create generic map.
        var mapArgs = {
            zoom: $el.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [{"color": "#f5f5f5"}]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#f5f5f5"}]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bdbdbd"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#ffffff"}]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dadada"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#c9c9c9"}]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                }
            ]
        };
        var map = new google.maps.Map($el[0], mapArgs);

        // Add markers.
        map.markers = [];
        $markers.each(function() {
            initMarker($(this), map);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @param   jQuery $marker The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position: latLng,
            map: map
        });

        // Append to reference for later use.
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, marker);
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function(marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
        // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    // Render maps on page load.
    jQuery(document).ready(function($) {
        $('.acf-map').each(function() {
            var map = initMap($(this));
        });
    });
}

// Initialize Google Maps
jQuery(document).ready(function($) {
    // Check if Google Maps API is loaded first
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        initGoogleMaps();
    } else {
        // If Google Maps API is loaded later, set up a callback
        window.initGoogleMapsCallback = function() {
            initGoogleMaps();
        };
    }
});

jQuery(document).ready(function($){
	var timelines = $('.b-timeline'),
		eventsMinDistance = 60;

	(timelines.length > 0) && initTimeline(timelines);

	function initTimeline(timelines) {
		timelines.each(function(){
			var timeline = $(this),
				timelineComponents = {};
			//cache timeline components
			timelineComponents['timelineWrapper'] = timeline.find('.events-wrapper');
			timelineComponents['eventsWrapper'] = timelineComponents['timelineWrapper'].children('.events');
			timelineComponents['fillingLine'] = timelineComponents['eventsWrapper'].children('.filling-line');
			timelineComponents['timelineEvents'] = timelineComponents['eventsWrapper'].find('a');
			timelineComponents['timelineDates'] = parseDate(timelineComponents['timelineEvents']);
			timelineComponents['eventsMinLapse'] = minLapse(timelineComponents['timelineDates']);
			timelineComponents['timelineNavigation'] = timeline.find('.cd-timeline-navigation');
			timelineComponents['eventsContent'] = timeline.children('.events-content');

			//assign a left postion to the single events along the timeline
			setDatePosition(timelineComponents, eventsMinDistance);
			//assign a width to the timeline
			var timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);
			//the timeline has been initialize - show it
			timeline.addClass('loaded');

			//detect click on the next arrow
			timelineComponents['timelineNavigation'].on('click', '.next', function(event){
				event.preventDefault();
				updateSlide(timelineComponents, timelineTotWidth, 'next');
			});
			//detect click on the prev arrow
			timelineComponents['timelineNavigation'].on('click', '.prev', function(event){
				event.preventDefault();
				updateSlide(timelineComponents, timelineTotWidth, 'prev');
			});
			//detect click on the a single event - show new event content
			timelineComponents['eventsWrapper'].on('click', 'a', function(event){
				event.preventDefault();
				timelineComponents['timelineEvents'].removeClass('selected');
				$(this).addClass('selected');
				updateOlderEvents($(this));
				updateFilling($(this), timelineComponents['fillingLine'], timelineTotWidth);
				updateVisibleContent($(this), timelineComponents['eventsContent']);
			});

			//on swipe, show next/prev event content
			timelineComponents['eventsContent'].on('swipeleft', function(){
				var mq = checkMQ();
				( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'next');
			});
			timelineComponents['eventsContent'].on('swiperight', function(){
				var mq = checkMQ();
				( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'prev');
			});

			//keyboard navigation
			$(document).keyup(function(event){
				if(event.which=='37' && elementInViewport(timeline.get(0)) ) {
					showNewContent(timelineComponents, timelineTotWidth, 'prev');
				} else if( event.which=='39' && elementInViewport(timeline.get(0))) {
					showNewContent(timelineComponents, timelineTotWidth, 'next');
				}
			});
		});
	}

	function updateSlide(timelineComponents, timelineTotWidth, string) {
	    // Retrieve translateX value of timelineComponents['eventsWrapper']
	    var translateValue = getTranslateValue(timelineComponents['eventsWrapper']),
	        wrapperWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', ''));

	    // Calculate how many events should be visible at once
	    var eventsPerPage = Math.floor(wrapperWidth / eventsMinDistance) - 1;

	    // Get all timeline event items
	    var allEvents = timelineComponents['eventsWrapper'].find('li');
	    var currentFirstVisible = Math.floor(Math.abs(translateValue) / eventsMinDistance);

	    // Calculate new translateX value based on direction
	    var newTranslateValue;
	    if (string == 'next') {
	        newTranslateValue = translateValue - wrapperWidth + eventsMinDistance;

	        // Update visibility of events
	        allEvents.each(function(index) {
	            var newIndex = index - currentFirstVisible - eventsPerPage;
	            if (newIndex >= 0 && newIndex < eventsPerPage) {
	                $(this).removeClass('hidden-event');
	            } else if (index < currentFirstVisible || index >= currentFirstVisible + eventsPerPage * 2) {
	                $(this).addClass('hidden-event');
	            }
	        });
	    } else { // prev
	        newTranslateValue = translateValue + wrapperWidth - eventsMinDistance;

	        // Update visibility of events
	        allEvents.each(function(index) {
	            var newFirstVisible = currentFirstVisible - eventsPerPage;
	            if (newFirstVisible < 0) newFirstVisible = 0;

	            if (index >= newFirstVisible && index < newFirstVisible + eventsPerPage) {
	                $(this).removeClass('hidden-event');
	            } else if (index >= newFirstVisible + eventsPerPage) {
	                $(this).addClass('hidden-event');
	            }
	        });
	    }

	    // Translate the timeline
	    translateTimeline(timelineComponents, newTranslateValue, wrapperWidth - timelineTotWidth);
	}

	function showNewContent(timelineComponents, timelineTotWidth, string) {
		//go from one event to the next/previous one
		var visibleContent =  timelineComponents['eventsContent'].find('.selected'),
			newContent = ( string == 'next' ) ? visibleContent.next() : visibleContent.prev();

		if ( newContent.length > 0 ) { //if there's a next/prev event - show it
			var selectedDate = timelineComponents['eventsWrapper'].find('.selected'),
				newEvent = ( string == 'next' ) ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');

			updateFilling(newEvent, timelineComponents['fillingLine'], timelineTotWidth);
			updateVisibleContent(newEvent, timelineComponents['eventsContent']);
			newEvent.addClass('selected');
			selectedDate.removeClass('selected');
			updateOlderEvents(newEvent);
			updateTimelinePosition(string, newEvent, timelineComponents, timelineTotWidth);
		}
	}

	function updateTimelinePosition(string, event, timelineComponents, timelineTotWidth) {
		//translate timeline to the left/right according to the position of the selected event
		var eventStyle = window.getComputedStyle(event.get(0), null),
			eventLeft = Number(eventStyle.getPropertyValue("left").replace('px', '')),
			timelineWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', '')),
			timelineTotWidth = Number(timelineComponents['eventsWrapper'].css('width').replace('px', ''));
		var timelineTranslate = getTranslateValue(timelineComponents['eventsWrapper']);

        if( (string == 'next' && eventLeft > timelineWidth - timelineTranslate) || (string == 'prev' && eventLeft < - timelineTranslate) ) {
        	translateTimeline(timelineComponents, - eventLeft + timelineWidth/2, timelineWidth - timelineTotWidth);
        }
	}

	function translateTimeline(timelineComponents, value, totWidth) {
		var eventsWrapper = timelineComponents['eventsWrapper'].get(0);
		value = (value > 0) ? 0 : value; //only negative translate value
		value = ( !(typeof totWidth === 'undefined') &&  value < totWidth ) ? totWidth : value; //do not translate more than timeline width
		setTransformValue(eventsWrapper, 'translateX', value+'px');
		//update navigation arrows visibility
		(value == 0 ) ? timelineComponents['timelineNavigation'].find('.prev').addClass('inactive') : timelineComponents['timelineNavigation'].find('.prev').removeClass('inactive');
		(value == totWidth ) ? timelineComponents['timelineNavigation'].find('.next').addClass('inactive') : timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
	}

	function updateFilling(selectedEvent, filling, totWidth) {
		//change .filling-line length according to the selected event
		var eventStyle = window.getComputedStyle(selectedEvent.get(0), null),
			eventLeft = eventStyle.getPropertyValue("left"),
			eventWidth = eventStyle.getPropertyValue("width");
		eventLeft = Number(eventLeft.replace('px', '')) + Number(eventWidth.replace('px', ''))/2;
		var scaleValue = eventLeft/totWidth;
		setTransformValue(filling.get(0), 'scaleX', scaleValue);
	}

	function setDatePosition(timelineComponents, min) {
	    for (var i = 0; i < timelineComponents['timelineDates'].length; i++) {
	        var distance = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][i]),
	            distanceNorm = Math.round(distance/timelineComponents['eventsMinLapse']) + 2;
	        timelineComponents['timelineEvents'].eq(i).css('left', distanceNorm*min+'px');
	    }
	}

	function setTimelineWidth(timelineComponents, width) {
	    // Calculate the normal timeline width based on dates
	    var timeSpan = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][timelineComponents['timelineDates'].length-1]),
	        timeSpanNorm = timeSpan/timelineComponents['eventsMinLapse'],
	        timeSpanNorm = Math.round(timeSpanNorm) + 4,
	        totalWidth = timeSpanNorm*width;

	    // Get the container width
	    var containerWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', ''));

	    // Set a minimum width to 125% of the container width
	    var minWidth = containerWidth * 1.25;

	    // Ensure the timeline is at least 125% as wide as its container
	    if (totalWidth < minWidth) {
	        // If we have few dates, adjust spacing while preserving relative distances
	        if (timelineComponents['timelineDates'].length > 1) {
	            // Calculate a scaling factor to expand the timeline to fill minimum width
	            var scaleFactor = minWidth / totalWidth;

	            // Get original positions first (preserving relative date distances)
	            var originalPositions = [];
	            for (var i = 0; i < timelineComponents['timelineDates'].length; i++) {
	                var distance = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][i]),
	                    distanceNorm = Math.round(distance/timelineComponents['eventsMinLapse']) + 2;
	                originalPositions.push(distanceNorm * width);
	            }

	            // Scale positions to fill minimum width
	            for (var i = 0; i < timelineComponents['timelineDates'].length; i++) {
	                // Apply scaling factor to the original position
	                var scaledPosition = originalPositions[i] * scaleFactor;
	                timelineComponents['timelineEvents'].eq(i).css('left', scaledPosition + 'px');
	            }

	            // Use minimum width as total width
	            totalWidth = minWidth;
	        } else {
	            // For a single date, place it at 25% of the container width
	            // This ensures the timeline is wider than the viewport
	            timelineComponents['timelineEvents'].eq(0).css('left', containerWidth * 0.25 + 'px');
	            totalWidth = minWidth;
	        }
	    }

	    // Set the width of the events wrapper
	    timelineComponents['eventsWrapper'].css('width', totalWidth+'px');

	    // Calculate how many events should be visible at once
	    var wrapperWidth = containerWidth;
	    var visibleItems = Math.floor(wrapperWidth / width) - 1;

	    // Hide all events beyond the visible range
	    var allEvents = timelineComponents['eventsWrapper'].find('li');
	    if (allEvents.length > visibleItems) {
	        allEvents.each(function(index) {
	            if (index >= visibleItems) {
	                $(this).addClass('hidden-event');
	            } else {
	                $(this).removeClass('hidden-event');
	            }
	        });

	        // Show navigation controls if we have more items than can fit
	        timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
	    } else {
	        // If all events fit but timeline is wider than container, still show navigation
	        timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
	    }

	    // Initially hide the prev button
	    timelineComponents['timelineNavigation'].find('.prev').addClass('inactive');

	    updateFilling(timelineComponents['timelineEvents'].eq(0), timelineComponents['fillingLine'], totalWidth);
	    return totalWidth;
	}

	function updateVisibleContent(event, eventsContent) {
		var eventDate = event.data('date'),
			visibleContent = eventsContent.find('.selected'),
			selectedContent = eventsContent.find('[data-date="'+ eventDate +'"]'),
			selectedContentHeight = selectedContent.height();

		if (selectedContent.index() > visibleContent.index()) {
			var classEnetering = 'selected enter-right',
				classLeaving = 'leave-left';
		} else {
			var classEnetering = 'selected enter-left',
				classLeaving = 'leave-right';
		}

		selectedContent.attr('class', classEnetering);
		visibleContent.attr('class', classLeaving).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
			visibleContent.removeClass('leave-right leave-left');
			selectedContent.removeClass('enter-left enter-right');
		});
		eventsContent.css('height', selectedContentHeight+'px');
	}

	function updateOlderEvents(event) {
		event.parent('li').prevAll('li').children('a').addClass('older-event').end().end().nextAll('li').children('a').removeClass('older-event');
	}

	function getTranslateValue(timeline) {
		var timelineStyle = window.getComputedStyle(timeline.get(0), null),
			timelineTranslate = timelineStyle.getPropertyValue("transform");

        if( timelineTranslate.indexOf('(') >=0 ) {
        	var timelineTranslate = timelineTranslate.split('(')[1];
    		timelineTranslate = timelineTranslate.split(')')[0];
    		timelineTranslate = timelineTranslate.split(',');
    		var translateValue = timelineTranslate[4];
        } else {
        	var translateValue = 0;
        }

        return Number(translateValue);
	}

	function setTransformValue(element, property, value) {
		element.style["transform"] = property+"("+value+")";
	}

	//based on http://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
	function parseDate(events) {
		var dateArrays = [];
		events.each(function(){
			var dateComp = $(this).data('date').split('/'),
				newDate = new Date(dateComp[2], dateComp[1]-1, dateComp[0]);
			dateArrays.push(newDate);
		});
	    return dateArrays;
	}

	function parseDate2(events) {
		var dateArrays = [];
		events.each(function(){
			var singleDate = $(this),
				dateComp = singleDate.data('date').split('T');
			if( dateComp.length > 1 ) { //both DD/MM/YEAR and time are provided
				var dayComp = dateComp[0].split('/'),
					timeComp = dateComp[1].split(':');
			} else if( dateComp[0].indexOf(':') >=0 ) { //only time is provide
				var dayComp = ["2000", "0", "0"],
					timeComp = dateComp[0].split(':');
			} else { //only DD/MM/YEAR
				var dayComp = dateComp[0].split('/'),
					timeComp = ["0", "0"];
			}
			var	newDate = new Date(dayComp[2], dayComp[1]-1, dayComp[0], timeComp[0], timeComp[1]);
			dateArrays.push(newDate);
		});
	    return dateArrays;
	}

	function daydiff(first, second) {
	    return Math.round((second-first));
	}

	function minLapse(dates) {
	    //determine the minimum distance among events
	    var dateDistances = [];
	    for (var i = 1; i < dates.length; i++) {  // Added 'var' to declare i
	        var distance = daydiff(dates[i-1], dates[i]);
	        dateDistances.push(distance);
	    }
	    return Math.min.apply(null, dateDistances);
	}

	/*
		How to tell if a DOM element is visible in the current viewport?
		http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
	*/
	function elementInViewport(el) {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while(el.offsetParent) {
		    el = el.offsetParent;
		    top += el.offsetTop;
		    left += el.offsetLeft;
		}

		return (
		    top < (window.pageYOffset + window.innerHeight) &&
		    left < (window.pageXOffset + window.innerWidth) &&
		    (top + height) > window.pageYOffset &&
		    (left + width) > window.pageXOffset
		);
	}

	function checkMQ() {
	    // Check if mobile or desktop device
	    try {
	        var timelineElement = document.querySelector('.b-timeline');
	        if (!timelineElement) return 'desktop'; // Default to desktop if element not found

	        var content = window.getComputedStyle(timelineElement, '::before').getPropertyValue('content');
	        return content.replace(/'/g, "").replace(/"/g, "") || 'desktop'; // Return cleaned content or default to desktop
	    } catch (e) {
	        console.warn('Error checking media query:', e);
	        return 'desktop'; // Default to desktop on error
	    }
	}
});


let currentMap = null;
let originalMapData = null;

// Then use it in your document ready function
jQuery(document).ready(function($) {
    // Look for the map loaded event
    $(document).on('geodir_map_loaded', function(e, map) {
        console.log('GeoDirectory map loaded');
        currentMap = map;

        // Store original marker data
        if (map && map.markers && !originalMapData) {
            originalMapData = [...map.markers];
        }
    });

    // Your service filter event handler
    $('#service-filter').on('change', function() {
        const selectedService = $(this).val();

        if (currentMap && originalMapData) {
            // Your filtering code here
            console.log('Current map parameters:', currentMap);
            console.log('Selected service:', selectedService);
        } else {
            console.error('Map not initialized yet');
        }
    });
});

// Add this reset function
function resetMap() {
    if (currentMap && originalMapData) {
        // Reset map to original markers
        console.log('Resetting map to original state');

        // Your reset logic here
        // For example:
        if (typeof geodir_map_post_type_terms === 'function') {
            const mapContainerId = currentMap.getDiv().id;
            geodir_map_post_type_terms(mapContainerId, 'gd_place', '', '');
        }
    }
}

function searchButton() {
    const el = document.querySelector('.c-primary-navigation');
    const form = document.querySelector('.c-search');
    const input = document.querySelector('.c-search__input');
    const open = document.querySelector('.c-search-icon svg');
    const close = document.querySelector('.c-search__close');
    const search = document.querySelector('.c-search__search') ?? null;
    if(!el) {
        return;
    }

    if(search) {
        search.addEventListener('click', function(e) {
            e.preventDefault();
            // Submit the form if search button is clicked
            if (input && form) {
                form.submit();
            }
        });
    }

    // Add event listener for Enter key press in search input
    if (input) {
        input.addEventListener('keypress', function(e) {
            // Check if the pressed key is Enter (key code 13)
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                // Submit the form when Enter is pressed
                if (form) {
                    form.submit();
                }
            }
        });
    }

    open.addEventListener('click', function(e) {
        e.preventDefault();
        el.classList.add('search-active');
        // Focus the input field when search is activated
        if(input) {
            setTimeout(() => {
                input.focus();
            }, 100); // Short delay to ensure DOM is updated
        }
    });

    close.addEventListener('click', function(e) {
        console.log('Close button clicked');
        e.preventDefault();
        // Blur/unfocus the input field before closing
        if(input) {
            input.blur();
        }
        el.classList.remove('search-active');
    });
}
searchButton();
